export default "__VITE_ASSET__DgQFsbsR__"